// ReadMore.jsx
import React, { useState, useRef, useEffect } from "react";
import "./GenAIDocumentDataCitationValue.css";

export default function GenAIDocumentDataCitationValue({ children, showFilters, lines = 2, customWidth, item }) {
    const contentRef = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const [showToggle, setShowToggle] = useState(false);

    // Measure after render to decide if content overflows when collapsed
    useEffect(() => {
        const el = contentRef.current;
        if (!el) return;

        // Ensure the element is in collapsed state for measurement
        el.classList.add("rm-collapsed");
        // Use RAF so styles have applied before measuring
        requestAnimationFrame(() => {
            // If scrollHeight > clientHeight then content overflows
            setShowToggle(el.scrollHeight > el.clientHeight + 1);
            // keep the class as-is; expanded state will toggle it later
        });
    }, [children, lines, customWidth]);
    useEffect(() => {
        setTimeout(() => {
            const el = contentRef.current;
            if (!el) return;

            // Ensure the element is in collapsed state for measurement
            el.classList.add("rm-collapsed");
            setShowToggle(el.scrollHeight > el.clientHeight + 1);
        }, 100);
    }, [showFilters, customWidth]);

    return (
        <div className="rm-wrapper">
            <div
                ref={contentRef}
                className={`rm-content ${expanded ? "rm-expanded" : "rm-collapsed"}`}
                // CSS fallback: allow dynamic clamp via custom property if desired
                style={{ ["--rm-lines"]: lines }}
                id="readmore-content"
            >
                {children}
            </div>

            {showToggle && (
                <button
                    className="rm-toggle"
                    onClick={() => setExpanded((s) => !s)}
                    aria-expanded={expanded}
                    aria-controls="readmore-content"
                >
                    {expanded ? "See Less" : "See More"}
                </button>
            )}
        </div>
    );
}
